module.exports = __webpack_public_path__ + "static/media/correct.c87ba8c8.png";